//mui
import {Theme} from '@mui/material';

export const MuiOutlinedInput = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			'&.Mui-error': {
				fieldset: {
					borderColor: theme.palette.error200,
				},
			},
		}),
	},
};

export const MuiInputLabel = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			fontSize: 12,
			lineHeight: '20px',
			color: theme.palette.neutral900,
			fontWeight: 400,
			position: 'relative' as any,
			left: 0,

			'&.Mui-error': {
				color: theme.palette.error500,
			},
			'&.Mui-disabled': {
				color: theme.palette.neutral200,
			},
		}),
	},
};

export const MuiInputBase = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			'&.MuiInputBase-root': {
				fontSize: 16,
				fontWeight: 400,
				lineHeight: '24px',
				letterSpacing: '0.15px',
				width: '100%',
				height: 44,
				'& input': {
					padding: '0 12px',
					color: theme.palette.neutral900,
					'&::placeholder': {
						color: theme.palette.neutral300,
						opacity: 1,
					},
				},
				'& textarea': {
					color: theme.palette.neutral900,
					'&::placeholder': {
						color: theme.palette.neutral300,
						opacity: 1,
					},
				},
				'& fieldset': {
					borderRadius: 'var(--default--border-radius)',
					border: `1px solid  ${theme.palette.neutral200}`,
				},
				'&:hover': {
					'& input::placeholder, textarea::placeholder': {
						color: theme.palette.neutral400,
					},
					'& fieldset': {
						border: `1px solid  ${theme.palette.neutral300}`,
					},
				},
				'&.Mui-focused': {
					color: theme.palette.neutral900,
					'& fieldset': {
						border: `1px solid ${theme.palette.primary500}`,
					},
				},
				'&.Mui-disabled': {
					color: theme.palette.neutral200,
					WebkitTextFillColor: theme.palette.neutral200,
					'& fieldset': {
						border: `1px solid ${theme.palette.neutral100}`,
					},
					'& input::placeholder': {
						WebkitTextFillColor: theme.palette.neutral200,
					},
					'& svg path': {
						fill: theme.palette.neutral200,
					},
				},
				'&.Mui-error': {
					'& input': {
						color: theme.palette.error500,
						'&::placeholder': {
							color: theme.palette.error500,
							opacity: 1,
						},
					},
					'& fieldset, &.Mui-focused fieldset': {
						borderColor: `${theme.palette.error200}`,
					},

					'& svg path': {
						fill: `${theme.palette.error500}`,
					},
				},
				'& .MuiInputAdornment-root': {
					marginLeft: 0,
				},
				'& .MuiIconButton-root': {
					'&:hover': {
						backgroundColor: 'unset',
					},
				},
			},
		}),
	},
	defaultProps: {
		autoComplete: 'off',
	},
};
